<template>
  <div class="col-sm-12 order-items">
    <div class="order-item-details tracking">
      <div class="col-md-12" :class="isMobile()?'order-details':'order-details'">
        <div class="row">
          <h3 class="col-md-9 store-name">{{order.StoreName}}</h3>
          <span class="col-md-3 order-number">{{(order.OrderNumber?'#':'')}}{{order.OrderNumber}}</span>
        </div>
        <span class="row tracking-date">{{getCreateDate()}}</span>
      </div>
      <div class="row" v-if="updateDisplayModel.status > -1">
        <div class="col-sm-12 d-flex justify-content-center multi-steps-wrapper">
          <ul class="list-unstyled multi-steps">
            <li :style="getStylesColor(1)">
              <span :style="getBeforStyle(1)"></span>
              <span>Order&nbsp;</span>
              <br v-if="isMobile()" />
              <span>Submitted</span>
              <span :style="getAfterStyle(1)"></span>
            </li>
            <li :style="getStylesColor(2)">
              <span :style="getBeforStyle(2)"></span>
              <span>Being&nbsp;</span>
              <br v-if="isMobile()" />
              <span>Prepared</span>
              <span :style="getAfterStyle(2)"></span>
            </li>
            <li :style="getStylesColor(3)">
              <span :style="getBeforStyle(3)"></span>
              <span>Ready</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12 text-center d-flex justify-content-center">
          <div v-if="updateDisplayModel.status ==-1" class="text-danger">
            <div>Your order has been rejected ({{order.OnlineOrderStatusDescription}})</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDiffMinsAccordingByStoreTimeZone } from "../../../api/helpers/datetimeZoneHelper";
import { getOrderStatus } from "../../../api/helpers/orderHelper";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "TrackingComponent",
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    store: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      minutes: 0
    };
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  computed: {
    ...mapGetters(["desktopStyles", "mobileStyles"]),
    updateDisplayModel() {
      var displayModel = {};
      //update status
      displayModel.status = getOrderStatus(this.order);
      switch (displayModel.status) {
        case -1:
          displayModel.orderMode = "Order Rejected";
          break;
        case 0:
          displayModel.orderMode = "Order Sent";
          break;
        case 3:
          displayModel.orderMode = "Order Submitted";
          break;
        case 1:
          displayModel.orderMode = "Being Prepared";
          break;
        case 2:
          displayModel.orderMode = "Ready";
          break;
      }
      this.$emit("update-status", displayModel.orderMode);
      return displayModel;
    }
  },
  mounted() {
    this.minutes = getDiffMinsAccordingByStoreTimeZone(
      this.store,
      this.order.ScheduledTime,
      moment()
    );
    var that = this;
    var checkRefreashPage = function() {
      that.minutes = getDiffMinsAccordingByStoreTimeZone(
        that.store,
        that.order.ScheduledTime,
        moment()
      );
      if (that.minutes < 0) {
        clearInterval(that.timerId);
      }
    };
    this.timerId = setInterval(checkRefreashPage, 1000);
  },
  methods: {
    getCreateDate() {
      if (this.order.CreatedOn)
        return moment(this.order.CreatedOn.toDate()).format("lll");
    },
    getBeforStyle(stepNo) {
      var styles = [];
      switch (stepNo) {
        case 1:
          if (
            this.updateDisplayModel.status >= 1 &&
            this.updateDisplayModel.status <= 3
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforeCommonColor
                : this.desktopStyles.stepProgressBarBeforeCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforePendingColor
                : this.desktopStyles.stepProgressBarBeforePendingColor
            );
          break;
        case 2:
          if (
            this.updateDisplayModel.status >= 1 &&
            this.updateDisplayModel.status <= 2
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforeCommonColor
                : this.desktopStyles.stepProgressBarBeforeCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforePendingColor
                : this.desktopStyles.stepProgressBarBeforePendingColor
            );
          break;
        case 3:
          if (this.updateDisplayModel.status == 2)
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforeCommonColor
                : this.desktopStyles.stepProgressBarBeforeCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarBeforePendingColor
                : this.desktopStyles.stepProgressBarBeforePendingColor
            );
          break;
      }
      return styles;
    },
    getAfterStyle(stepNo) {
      var styles = [];
      switch (stepNo) {
        case 1:
          if (
            this.updateDisplayModel.status >= 1 &&
            this.updateDisplayModel.status <= 2
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterCommonColor
                : this.desktopStyles.stepProgressBarAfterCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterPendingColor
                : this.desktopStyles.stepProgressBarAfterPendingColor
            );
          break;
        case 2:
          if (this.updateDisplayModel.status == 2)
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterCommonColor
                : this.desktopStyles.stepProgressBarAfterCommonColor
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.stepProgressBarAfterPendingColor
                : this.desktopStyles.stepProgressBarAfterPendingColor
            );
          break;
      }
      return styles;
    },
    getStylesColor(stepNo) {
      var styles = [];
      switch (stepNo) {
        case 1:
          if (
            this.updateDisplayModel.status >= 1 &&
            this.updateDisplayModel.status <= 3
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.CommonColorTxt
                : this.desktopStyles.CommonColorTxt
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.StatusPendingTxt
                : this.desktopStyles.StatusPendingTxt
            );
          break;
        case 2:
          if (
            this.updateDisplayModel.status >= 1 &&
            this.updateDisplayModel.status <= 2
          )
            styles.push(
              this.isMobile()
                ? this.mobileStyles.CommonColorTxt
                : this.desktopStyles.CommonColorTxt
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.StatusPendingTxt
                : this.desktopStyles.StatusPendingTxt
            );
          break;
        case 3:
          if (this.updateDisplayModel.status == 2)
            styles.push(
              this.isMobile()
                ? this.mobileStyles.CommonColorTxt
                : this.desktopStyles.CommonColorTxt
            );
          else
            styles.push(
              this.isMobile()
                ? this.mobileStyles.StatusPendingTxt
                : this.desktopStyles.StatusPendingTxt
            );
          break;
      }
      return styles;
    }
  }
};
</script>
